import type { UpdateContractResponse, UpdateContractRequestPayload } from '@vy/api-definition';
import { UpdateContractResponseSchema } from '@vy/api-definition';
import type { VyInternalApiError, VyValidationError } from '@vy/error';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type UpdateContractRequest = {
  updateContractRequest: UpdateContractRequestPayload;
  contractId: string;
};

export function useUpdateContract(
  options?: UseMutationOptions<
    UpdateContractResponse,
    VyInternalApiError<VyValidationError> | undefined,
    UpdateContractRequest
  >,
) {
  return useMutation({
    mutationFn: async ({ contractId, updateContractRequest }) => {
      const api = getPrivateApi();
      const updateContractResponse = await api.updateContract({
        contractId,
        updateContractRequest,
      });

      return UpdateContractResponseSchema.parse(updateContractResponse);
    },
    ...options,
  });
}
